import React from 'react';
import { Row, Container } from 'react-bootstrap';
import { IModifierGroupsComponent } from '../../../../../models/try2Combo';
import styleClasses from '../../../try2.module.scss';
import ItemModifierGroups from './ModifierGroups/ItemModifierGroups';
import { Accordion } from 'react-bootstrap';
import { DO_NOT_SHOW } from '../../../../../constants';
const ModifierGroups: React.FC<IModifierGroupsComponent> = (props) => {
  const {
    modifierGroups,
    selectedAddOns,
    selectedCore,
    isLimitExceed,
    handleClick,
    isItEdit,
    openFirstAccordion,
  } = props;

  const [openAccordions, setOpenAccordions] = React.useState<string[]>(
    openFirstAccordion ? ['0'] : []
  );

  const handleToggle = (id: string): void => {
    const indexOfCurrentId: number = openAccordions.indexOf(id);
    const newData: string[] = [...openAccordions];
    if (indexOfCurrentId === -1) {
      newData.push(id);
      setOpenAccordions(newData);
    } else {
      newData.splice(indexOfCurrentId, 1);
      setOpenAccordions(newData);
    }
  };

  const showGroup = (ingredients) => {
    if (ingredients?.name?.toLowerCase().includes(DO_NOT_SHOW)) {
      return false;
    } else {
      return true;
    }
  };
  return (
    <>
      {modifierGroups &&
        modifierGroups.map((ingredients, index) => {
          const label = ingredients?.label?.toLowerCase();
          return (
            <>
              {ingredients?.modifiers_groups_modifiers?.length > 0 ? (
                <React.Fragment>
                  {showGroup(ingredients) ? (
                    <Container
                      fluid
                      className={`${styleClasses.try2_all_dressing}`}
                      key={ingredients?.id}
                    >
                      <Accordion
                        className="modifiers-accordions-wrapper"
                        activeKey={openAccordions}
                      >
                        <Accordion.Item eventKey={`${index}`} key={index}>
                          <Accordion.Header
                            className="py-3 py-md-0"
                            onClick={() => handleToggle(index.toString())}
                          >
                            <span className="d-block text-capitalize f-sm-s18">
                              {label}
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            <Row>
                              <ItemModifierGroups
                                ingredients={ingredients}
                                selectedAddOns={selectedAddOns}
                                selectedCore={selectedCore}
                                handleClick={handleClick}
                                isLimitExceed={isLimitExceed}
                                isItEdit={isItEdit}
                                itemModifierItemModalWidth={''}
                              />
                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </Container>
                  ) : null}
                </React.Fragment>
              ) : null}
            </>
          );
        })}
    </>
  );
};

export default ModifierGroups;
